module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Bold-a37a602b319bcc58016665f2450420d4.svg";